import React from 'react';
import { useParams } from 'next/navigation';
import { Index } from 'react-instantsearch-hooks';
import {
  productsIndex_NZ,
  productsIndex_AU,
  productsSearchIndex_AU,
  productsSearchIndex_NZ,
  contentIndex_AU,
  contentIndex_NZ,
  bimLibraryIndex_AU,
  bimLibraryIndex_NZ,
} from 'helpers/constants/algolia';

interface Props {
  type: 'products' | 'content' | 'bim-library';
  isSearch?: boolean;
  skipSortSearch?: boolean;
}

export const useLocalizedIndex = ({ type, isSearch, skipSortSearch = true }: Props) => {
  const { locale, slug } = useParams();
  const isSearchPage = ((slug?.indexOf('search') !== -1) || isSearch) && skipSortSearch;
  const indexes = {
    products: {
      au: isSearchPage ? productsSearchIndex_AU : productsIndex_AU,
      nz: isSearchPage ? productsSearchIndex_NZ : productsIndex_NZ,
    },
    content: {
      au: contentIndex_AU,
      nz: contentIndex_NZ,
    },
    'bim-library': {
      au: bimLibraryIndex_AU,
      nz: bimLibraryIndex_NZ,
    },
  };

  const indexName = indexes[slug === 'tools-resources/bim-library' && !isSearch ? 'bim-library' : type][locale as 'au' | 'nz'];

  return { indexName };
};

const LocalizedIndex = ({ children, type, isSearch }: React.PropsWithChildren<Props>) => {
  const { indexName } = useLocalizedIndex({ type, isSearch });

  return <Index indexName={indexName}>{children}</Index>;
};

export default LocalizedIndex;
